import "./GarageDoorRepairSutherlandShire.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import GarageService from "./sections/GarageService";
import GarageServices from "./sections/GarageServices";
import ServiceAreas from "./sections/ServiceAreas";
import GarageProcess from "./sections/GarageProcess";
import WhyChooseSutherlandShire from "./sections/WhyChooseSutherlandShire";
import Sutherland from "./sections/Sutherland";
import Testimonials from "./sections/Testimonials";
import GarageFaq from "./sections/GarageFaq";
import GarageAppointment from "./sections/GarageAppointment";
import SiteFooter from "./sections/SiteFooter";
export default function GarageDoorRepairSutherlandShirePage() {
  return <div>
      <Header />
      <GarageHero />
      <GarageService />
      <GarageServices />
      <ServiceAreas />
      <GarageProcess />
      <WhyChooseSutherlandShire />
      <Sutherland />
      <Testimonials />
      <GarageFaq />
      <GarageAppointment />
      <SiteFooter />
    </div>;
}